import React from "react";
import { Form } from "antd";
import {
  DropdownSelect,
  MultiFieldSelector,
  MultiSelector,
  MultiColorSelector,
  RangeControl,
  GroupMultiLevelSelect
} from "../../../FormControls";
import { ControlType, DataSource } from "../../../../models";
import { MakeList } from "../../../FormControls/MakeList";
import { MultiMakeSelector } from "../../../FormControls/MultiMakeSelector";
import { SearchLocation } from "../../../FormControls/SearchLocation";
import { MultiFieldSelectorCheckBox } from "../../../FormControls/MultiFieldSelectorCheckBox";
import SearchInputLocation from "../../../FormControls/SearchInputLocation";
import styles from "./styles.scss";

// eslint-disable-next-line complexity
const SearchControl = props => {
  const {
    controlConfig,
    form,
    isMobile,
    onSubmit,
    showPlaceholder,
    isSearch,
    showAllControls,
    setShowAllControls,
    isColumn,
    searchPage,
    getPopupContainer
  } = props;
  const renderFormItem = (control, component, isCheckboxField) => (
    <Form.Item
      key={control.id}
      style={{
        marginBottom: `${showPlaceholder && "0"}`
      }}
      className={`${styles.all} ${isCheckboxField ? "checkboxField" : ""}`}
      data-field-id={control.id}
    >
      {form.getFieldDecorator(control.id, {
        initialValue: control.data
      })(component)}
    </Form.Item>
  );

  switch (controlConfig.type) {
    case ControlType.singleSelector:
      return renderFormItem(
        controlConfig,
        <DropdownSelect {...controlConfig} showPlaceholder={showPlaceholder} getPopupContainer={getPopupContainer} />
      );

    case ControlType.multiFieldSelector:
      return renderFormItem(
        controlConfig,
        <MultiFieldSelector
          {...controlConfig}
          fullWidth
          showPlaceholder={showPlaceholder}
          getPopupContainer={getPopupContainer}
        />
      );

    case ControlType.checkbox:
      return renderFormItem(
        controlConfig,
        <MultiFieldSelectorCheckBox
          {...controlConfig}
          fullWidth
          showPlaceholder={showPlaceholder}
          isSearch={true}
        />,
        true
      );

    case ControlType.multiSelector:
      return renderFormItem(
        controlConfig,
        <MultiSelector {...controlConfig} showPlaceholder={showPlaceholder} getPopupContainer={getPopupContainer}/>
      );

    case ControlType.range:
      return renderFormItem(
        controlConfig,
        <RangeControl
          hideSuggestions={isMobile}
          {...controlConfig}
          showPlaceholder={showPlaceholder}
          showAllControls={showAllControls}
        />
      );

    case ControlType.multiColorSelector:
      return renderFormItem(
        controlConfig,
        <MultiColorSelector
          {...controlConfig}
          showPlaceholder={showPlaceholder}
        />
      );

    case ControlType.inputLocation:
      return renderFormItem(
        controlConfig,
        <SearchInputLocation
          {...controlConfig}
          showPlaceholder={showPlaceholder}
          getPopupContainer={getPopupContainer}
        />
      );

    case ControlType.multiLevel:
      return renderFormItem(
        controlConfig,
        !isSearch ? (
          <GroupMultiLevelSelect
            {...controlConfig}
            isMultiRows={isMobile ? true : controlConfig.isMultiRows}
            onSubmit={onSubmit}
            isMobile={isMobile}
            showPlaceholder={showPlaceholder}
            isSingleElement={true}
            getPopupContainer={getPopupContainer}
          />
        ) : controlConfig.dataSource == DataSource.make ? (
          <MultiMakeSelector
            {...controlConfig}
            showPlaceholder={showPlaceholder}
            isColumn={isColumn}
            getPopupContainer={getPopupContainer}
          />
        ) : (
          <SearchLocation
            {...controlConfig}
            isMultiRows={false}
            onSubmit={onSubmit}
            isMobile={isMobile}
            showPlaceholder={showPlaceholder}
            isSingleElement={true}
            showAllControls={showAllControls}
            isColumn={isColumn}
            searchPage={searchPage}
            getPopupContainer={getPopupContainer}
          />
        )
      );

    default:
      return null;
  }
};

SearchControl.defaultProps = {
  isSearch: false
};

export default SearchControl;



// WEBPACK FOOTER //
// ./src/components/SearchControls/SearchGroups/SearchControl/index.tsx